
"use strict"

// Components

import toggle from './navigation'
import asyncLoadOnScroll from './asyncLoadOnScroll'
import videoLightbox from './components/videoLightbox'
import textCarousel from './components/text-carousel'
import textImageCarousel from './components/text-image-carousel'
import carousel from './components/testimonials'
import tabbedArticles from './components/tabbed-content-article'
import tabbedContent from './components/tabbed-content'
import expand from './components/expand'
import eventsFilter from './components/events-filter'
import teamCarousel from './components/team-carousel'
import objectFitImages from 'object-fit-images'

// load
const els = [...document.querySelectorAll('.load')]

els.map(scroll => {
    asyncLoadOnScroll(scroll, function(el) {
        el.classList.add('loaded')
    })
})

// polyfills 
objectFitImages()

// init
videoLightbox()
carousel()
textCarousel()
teamCarousel()
tabbedArticles()
tabbedContent()
eventsFilter()
textImageCarousel()

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})

document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')